@if (isDimension()) {
    <div class="bg-card shadow-md rounded p-2">
        <nav>
            <div class="nav nav-tabs">
                <button class="nav-link" [class.active]="activeTab === 1" type="button" (click)="activeTab = 1">
                    {{ "metrics.table_view" | translate }}
                </button>
                <button class="nav-link" [class.active]="activeTab === 2" type="button" role="tab" (click)="activeTab = 2">
                    {{ "metrics.chart_view" | translate }}
                </button>
            </div>
        </nav>
        <div class="tab-content">
            <div class="tab-pane p-2 fade" [class]="activeTab === 1 ? 'show active' : ''" role="tabpanel">
                <adaa-data-table
                    #adaaDataTable
                    [isLocalData]="true"
                    [localData]="metricReadings()"
                    [configKey]="metricTableConfig()"
                    [enableAdd]="false"
                    [enableViewAction]="isMetricPage()"
                    [enableEditAction]="!isMetricPage()"
                    [enableDeleteAction]="!isMetricPage()"
                    [enableActionsCell]="enableActionCell()"
                    [disableEditRules]="disableEditRules"
                    [disableDeleteRules]="disableDeleteRules"
                    [customActionButtons]="customActionButtons()"
                    (actionClicked)="getAction($event)"
                />
            </div>
            <div class="tab-pane p-2 fade" [class]="activeTab === 2 ? 'show active' : ''" role="tabpanel">
                <div class="d-flex w-100 justify-content-end mb-1">
                    <adaa-chart-action-buttons elementId="metricReadingsChart" [enableDownloadCSV]="false" />
                </div>
                <canvas
                    id="metricReadingsChart"
                    baseChart
                    type="line"
                    [labels]="chartLabels()"
                    [datasets]="chartDataset()"
                    [options]="chartOptions()"
                ></canvas>
            </div>
        </div>
    </div>
} @else {
    <adaa-data-table
        #adaaDataTable
        [isLocalData]="true"
        [localData]="metricReadings()"
        [configKey]="metricTableConfig()"
        [enableAdd]="false"
        [enableViewAction]="isMetricPage()"
        [enableEditAction]="!isMetricPage()"
        [enableDeleteAction]="!isMetricPage()"
        [enableActionsCell]="enableActionCell()"
        [disableEditRules]="disableEditRules"
        [disableDeleteRules]="disableDeleteRules"
        [customActionButtons]="customButtons()"
        (actionClicked)="getAction($event)"
    />
}

<adaa-metrics-reading-editor #readingEditor (defaultValue)="setValue($event)" />
